import { useEffect, useRef } from "react";
import { trackEvent } from "@/lib/track";

// Reports "this section was seen" once per visit. It answers the one question
// the owner could not answer before: does the reader ever reach the offer?
// Threshold is low (15 %) because a tall section can never be 40 % visible on a
// phone screen.
export function TrackedSection({ id, token, className, children }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return undefined;
    let fired = false;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !fired) {
          fired = true;
          trackEvent(token, "section_viewed", { section: id });
          io.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [id, token]);
  return <section id={id === "offer" ? undefined : id} ref={ref} className={className}>{children}</section>;
}
